import {
  AccountsManagementParam,
  PatchAccountsDetailsData
} from '@/Interfaces/I_AccountsManagement';

import { customAxios } from '../index';

import type { StreamerData } from '../../interface/I_AccountsManagement';

export const fetchAccountsManangement = (data: AccountsManagementParam) =>
  customAxios({
    url: 'hktv_koc/cms/accounts',
    method: 'GET',
    params: data,
  });

export const searchAccounts = ({
  search,
  page = 0,
  size = 10,
}: {
  search: string;
  page: number;
  size: number;
}) =>
  customAxios({
    url: 'hktv_koc/cms/accounts/search',
    method: 'GET',
    params: {
      search,
      page,
      size,
    },
  });

export const putUserDetailsApi = ({ userUuid, ...data }: PatchAccountsDetailsData) =>
  customAxios({
    url: `hktv_koc/cms/accounts/${userUuid}`,
    method: 'PATCH',
    data,
  });
